import { render, staticRenderFns } from "./UniversityTemplateCriteria.vue?vue&type=template&id=390bb98e&scoped=true&"
import script from "./UniversityTemplateCriteria.vue?vue&type=script&lang=js&"
export * from "./UniversityTemplateCriteria.vue?vue&type=script&lang=js&"
import style0 from "./UniversityTemplateCriteria.vue?vue&type=style&index=0&id=390bb98e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390bb98e",
  null
  
)

export default component.exports